type IVProps = {
  data: {
    backgroundCheck: boolean
    insurance: boolean
    identity: boolean
    usdot: boolean
    usda: boolean
    manual: boolean
  }
}
const DriverVerifications: React.FC<IVProps> = ({ data }) => {
  const { identity, insurance, backgroundCheck, usda } = data
  return (
    <>
      {identity && (
        <div className="relative flex justify-start items-center mb-2">
          <span className="w-6 h-6 mr-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current text-secondary-500"
            >
              <path d="M4.34074 3.85264C4.41791 2.80809 5.2879 2 6.3353 2H17.8468C19.0094 2 19.927 2.9879 19.8414 4.14736L18.6593 20.1474C18.5821 21.1919 17.7121 22 16.6647 22H5.15321C3.99059 22 3.07299 21.0121 3.15865 19.8526L4.34074 3.85264Z"></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3497 10.5071C14.3497 11.6005 13.8859 12.5654 13.1791 13.1398C15.3921 13.5286 17.014 14.6857 17.0864 16.0647H6C6.07451 14.6444 7.79272 13.4596 10.1075 13.1069C9.42304 12.5291 8.97656 11.58 8.97656 10.5071C8.97656 8.74622 10.1794 7.31873 11.6631 7.31873C13.1469 7.31873 14.3497 8.74622 14.3497 10.5071Z"
                fill="white"
              ></path>
            </svg>
          </span>
          <span className="text-bs leading-none text-neutral-700 whitespace-nowrap">
            Identity verified
          </span>
        </div>
      )}
      {backgroundCheck && (
        <div className="relative flex justify-start items-center mb-2">
          <span className="w-6 h-6 mr-2">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current text-secondary-500"
            >
              <path d="M12.5 1L3.5 5V11C3.5 16.55 7.34 21.74 12.5 23C17.66 21.74 21.5 16.55 21.5 11V5L12.5 1ZM10.5 17L6.5 13L7.91 11.59L10.5 14.17L17.09 7.58L18.5 9L10.5 17Z"></path>
            </svg>
          </span>
          <span className="text-bs leading-none text-neutral-700 whitespace-nowrap">
            Background checked
          </span>
        </div>
      )}
      {usda && (
        <div className="relative flex justify-start items-center mb-2">
          <span className="w-6 h-6 mr-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current text-secondary-500"
            >
              <g clipPath="url(#clip0_4012_5152)">
                <mask
                  id="mask0_4012_5152"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <path d="M24 0H0V24H24V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_4012_5152)">
                  <path
                    d="M17 19.22H5V7H12V5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V12H17V19.22Z"
                    fill="#9F6D25"
                  />
                  <path d="M14 9H7V11H14V9Z" fill="#9F6D25" />
                  <path d="M7 12V14H15V12H12H7Z" fill="#9F6D25" />
                  <path d="M15 15H7V17H15V15Z" fill="#9F6D25" />
                  <path
                    d="M17.0729 7.17307L15.7313 5.8315L14.3113 7.2415L17.0729 10.003L22.7089 4.36703L21.2989 2.95703L17.0729 7.17307Z"
                    fill="#9F6D25"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_4012_5152">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span className="text-bs leading-none text-neutral-700 whitespace-nowrap">
            USDA registered
          </span>
        </div>
      )}
      {insurance && (
        <div className="flex items-center space-x-2">
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_4012_5168"
              maskUnits="userSpaceOnUse"
              x="2"
              y="2"
              width="21"
              height="20"
            >
              <path d="M22.5 2H2.5V22H22.5V2Z" fill="white" />
            </mask>
            <g mask="url(#mask0_4012_5168)">
              <path
                d="M14.375 2H4.79167C3.525 2 2.5 3.025 2.5 4.29167V17.2083C2.5 18.475 3.525 19.5 4.79167 19.5H11.5833C10.8833 18.3917 10.4167 17.0833 10.4167 15.5833V13.55C10.2917 13.625 10.15 13.6667 10 13.6667H5.83333C5.375 13.66667 5 13.2917 5 12.8333C5 12.375 5.375 12 5.83333 12H10C10.1583 12 10.3 12.0417 10.425 12.1167C10.4583 11.4083 10.7917 10.7583 11.3167 10.3333H5.83333C5.375 10.3333 5 9.95833 5 9.5C5 9.04167 5.375 8.66667 5.83333 8.66667H13.3333C13.6833 8.66667 13.9833 8.88333 14.1083 9.19167L16.4833 8.38333C16.5417 8.35833 16.6 8.34167 16.6667 8.33333V4.29167C16.6667 3.025 15.6417 2 14.375 2ZM9.16667 7H5.83333C5.375 7 5 6.625 5 6.16667C5 5.70833 5.375 5.33333 5.83333 5.33333H9.16667C9.625 5.33333 10 5.70833 10 6.16667C10 6.625 9.625 7 9.16667 7Z"
                fill="#9F6D25"
              />
              <path
                d="M21.935 11.4492L17.56 9.96087C17.3858 9.90171 17.1967 9.90171 17.0225 9.96087L12.6475 11.4492C12.31 11.5642 12.0825 11.8817 12.0825 12.2383V15.5867C12.0825 19.8092 16.765 21.8492 16.9642 21.9342C17.0692 21.9783 17.1808 22 17.2917 22C17.4025 22 17.5142 21.9783 17.6183 21.9333C17.8175 21.8483 22.5 19.8092 22.5 15.5867V12.2383C22.5 11.8808 22.2733 11.5642 21.935 11.4492ZM20.25 14.5833L17.75 17.9167C17.605 18.11 17.3842 18.2308 17.1425 18.2475C17.1225 18.2492 17.1025 18.25 17.0833 18.25C16.8625 18.25 16.6508 18.1633 16.4942 18.0058L14.8275 16.3392C14.5017 16.0133 14.5017 15.4867 14.8275 15.1608C15.1533 14.835 15.68 14.835 16.0058 15.1608L16.9933 16.1483L18.9167 13.5833C19.1925 13.2158 19.715 13.14 20.0825 13.4167C20.4517 13.6925 20.5267 14.215 20.25 14.5833Z"
                fill="#9F6D25"
              />
            </g>
          </svg>

          <p className="text-sm">Insurance verified</p>
        </div>
      )}
      <div className="relative flex justify-start items-center mb-2">
        <span className="w-6 h-6 mr-2">
          <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 12.125c0-3.154 0-4.731.887-5.783.14-.165.293-.318.458-.457C5.4 5 6.98 5 10.141 5h.354c3.161 0 4.742 0 5.796.885.165.139.319.292.458.457.43.51.65 1.141.765 2.015l2.967-1.554a.354.354 0 0 1 .519.313V17.13a.354.354 0 0 1-.52.312l-2.962-1.576c-.114.888-.335 1.528-.769 2.042a3.77 3.77 0 0 1-.458.457c-1.054.885-2.635.885-5.796.885h-.354c-3.161 0-4.742 0-5.796-.885a3.766 3.766 0 0 1-.458-.457C3 16.856 3 15.279 3 12.125Zm7.271-4.357 1.161.212c.545.1.906.621.806 1.165l-.382 2.082 3.08.524-.198 1.161a1.003 1.003 0 0 1-1.157.819l-2.118-.36-.568 3.093-1.161-.212a1.001 1.001 0 0 1-.806-1.165l.382-2.083-3.08-.524.198-1.16a1.003 1.003 0 0 1 1.157-.82l2.118.361.568-3.093Z"
              fill="#9F6D25"
            />
          </svg>
        </span>
        <span className="text-bs leading-none text-neutral-700 whitespace-nowrap">
          24/7 On-call vet
        </span>
      </div>
    </>
  )
}
export default DriverVerifications
